// extracted by mini-css-extract-plugin
export default {"icon_img":"Vy","banner_wrapper":"Wy","banner":"Xy","title_wrapper":"Yy","icons":"Zy","weekly_freq":"az","icon":"bz","icon_title":"cz"};
    if(module.hot) {
      // 1714422956043
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  